var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJfkMenuIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 80,
    viewBox: "0 0 42 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.84863 16.498V28.6416H7.02246V16.498H11.8701V28.6416H14.0391V16.5039H18.8877V32.1719C18.8876 35.8867 16.7461 39.0967 13.6357 40.6455V70H5V40.5107C2.02404 38.917 0 35.7799 0 32.166V16.498H4.84863ZM35.3643 10C38.9511 10 41.8603 12.9066 41.8604 16.498V70H33.2236V49.4893H25.2207L28.9082 15.8418V15.791C29.2613 12.5363 32.0135 10 35.3594 10H35.3643Z",
    fill: "#003972"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJfkMenuIcon);
export default __webpack_public_path__ + "static/media/jfk_menu_icon.b259eb980ec507186602dfa247871cc4.svg";
export { ForwardRef as ReactComponent };